import { Controller } from '@hotwired/stimulus'
import { createPopper } from '@popperjs/core'

export default class extends Controller {
  static targets = ['menu']
  static values = {
    placement: { type: String, default: 'bottom' },
    offset: { type: Number, default: 8 },
    alignment: { type: String, default: 'left' },
  }

  connect() {
    document.addEventListener('click', this.handleClickOutside.bind(this))
    document.addEventListener('keydown', this.handleEscape.bind(this))

    // Initialize Popper
    this.popper = createPopper(this.element, this.menuTarget, {
      placement:
        this.alignmentValue === 'right' ? 'bottom-end' : 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, this.offsetValue],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements:
              this.alignmentValue === 'right' ? ['top-end'] : ['top-start'],
            padding: 8,
          },
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport',
            padding: 8,
            altAxis: true,
          },
        },
        {
          name: 'computeStyles',
          options: {
            adaptive: true,
            gpuAcceleration: false,
          },
        },
      ],
    })
  }

  showImpersonating() {
    const alertDiv = document.getElementById('impersonating-user-message')
    if (alertDiv) {
      alertDiv.classList.remove('tw-hidden')
    }
  }

  hideImpersonating() {
    const alertDiv = document.getElementById('impersonating-user-message')
    if (alertDiv) {
      alertDiv.classList.add('tw-hidden')
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
    document.removeEventListener('keydown', this.handleEscape.bind(this))
    if (this.popper) {
      this.popper.destroy()
    }
  }

  toggle() {
    this.menuTarget.classList.toggle('tw-hidden')
    if (!this.menuTarget.classList.contains('tw-hidden')) {
      this.popper.update()
    }
  }

  close() {
    this.menuTarget.classList.add('tw-hidden')
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
